

/*---------------------------------------*/
/* タブ切り替え
/*---------------------------------------*/
$(window).on('load', function() {
	$('.js-list-tab > li, .js-content-tab > *').removeClass('is-active');
	$('.js-list-tab li:first-child').addClass('is-active');
	$('.js-content-tab > div:first-child').addClass('is-active');
});
$('.js-list-tab li').on('click', function() {
	$('.js-list-tab > li, .js-content-tab > *').removeClass('is-active');
	$(this).addClass('is-active');
	var index = $('.js-list-tab li').index(this);
	$('.js-content-tab > *').eq(index).addClass('is-active');
});

/*---------------------------------------*/
/* スライダー MV*/
/*---------------------------------------*/
$(".slider-mv").slick({
// autoplay: true, 
speed: 200,
centerMode: true,
centerPadding: "10%",
variableWidth: true,
useTransform: false,
dots: true,
prevArrow: '<button type=button class=slider_prev><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_left.svg?v=7351048273732688647" alt=""></button>',
nextArrow: '<button type=button class=slider_next><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_right.svg?v=2386108658303881462" alt=""></button>',
cssEase: 'ease-out',
responsive: [
	{
		breakpoint: 749, // 399px以下のサイズに適用
		settings: {
		centerPadding: 0,
		variableWidth: false,
		},
	},
	],

});
$(function(){
	$('.CM').css('display','block');
});


/*---------------------------------------*/
/* スライダー 4枚*/
/*---------------------------------------*/
$(".slider04").slick({
// autoplay: true, 
speed: 200,
slidesToShow: 4,
useTransform: false,
dots: false,
prevArrow: '<button type=button class=slider_prev><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_left.svg?v=7351048273732688647" alt=""></button>',
nextArrow: '<button type=button class=slider_next><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_right.svg?v=2386108658303881462" alt=""></button>',
cssEase: 'ease-out',
responsive: [
	{
		breakpoint: 749, // 399px以下のサイズに適用
		settings: {
		slidesToShow: 2,
		},
	},
	],
});
/*---------------------------------------*/
/* スライダー 3枚*/
/*---------------------------------------*/
$(".slider03").slick({
autoplay: true, // 自動でスクロール
autoplaySpeed: 3500, // 自動再生のスライド切り替えまでの時間を設定
speed: 200,
slidesToShow: 3,
useTransform: false,
dots: false,
prevArrow: '<button type=button class=slider_prev><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_left.svg?v=7351048273732688647" alt=""></button>',
nextArrow: '<button type=button class=slider_next><img src="//shinchan-online.jp/cdn/shop/files/arrow_circle_right.svg?v=2386108658303881462" alt=""></button>',
cssEase: 'ease-out',
responsive: [
	{
		breakpoint: 749, // 399px以下のサイズに適用
		settings: {
		slidesToShow: 1,
		},
	},
	],
});


/*---------------------------------------*/
/* ハンバーガーメニュー
/*---------------------------------------*/
$('.menu-trigger').on('click',function() {
	$('body').toggleClass('is-fixed');
} );
	// $('#menu a[href]').on('click', function(event) {
	// $('.menu-trigger').trigger('click');
// });


